export default __webpack_public_path__ + "static/media/12-SunsetWalk.072cee19.jpeg";